define('views/transfer/searched-user',[
    'backbone',
    'views/_base/baseview',
    'text!views/transfer/searched-user.html'
], function(Backbone, BaseView, Template){
    'use strict';

    return BaseView.extend({
		tagName : 'li',
		className: 'select-option',
		isRender: true,
		template: _.template(Template),
		events  : {
			'click': 'handleClick'
		},
        initialize: function(options){
			options = options || {};

			this.user = options.user;
			this.parent_view = options.parent_view;

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
        },

		render: function(){

			this.$el.data('user-guid', this.user_guid).data('entity-id', enums.entityTypeEnum.Consumer).html(this.template());
			
			return this;
		},

		handleClick: function(e){
			this.parent_view.populateParentViewFieldsMODAL(this.user);
		}
		
    });
});

